module.exports = __webpack_public_path__ + "static/media/oxy-tea.520d5bfe.png";